import { render, staticRenderFns } from "./StartDescriptions.vue?vue&type=template&id=63976d33"
import script from "./StartDescriptions.vue?vue&type=script&lang=js"
export * from "./StartDescriptions.vue?vue&type=script&lang=js"
import style0 from "./StartDescriptions.vue?vue&type=style&index=0&id=63976d33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports